import React from "react";
import InputForm from "../../../components/Input/InputForm";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import Participantes from "./Participantes";
import { withStyles } from "@material-ui/core";

const TestePaternidade = observer(({ classes, exameStore }) => {
  const handleChange = (value, field) => {
    exameStore.exame[field] = value;
  
  };

  return (
    <div>
      <div className={classes.content}>
        <div>
          <label className={classes.label}>Coletador:</label>
          <InputForm
            id="pac-tpt-inp-col"
            classes={{ input: classes.input }}
            onChange={(e) => handleChange(e?.target?.value, "nomeColetador")}
            value={exameStore?.exame?.nomeColetador || ""}
          />
        </div>
        <div>
          <label className={classes.label}>
            Nome do juiz (somente casos juduciais):
          </label>
          <InputForm
            id="pac-tpt-inp-jui"
            classes={{ input: classes.input }}
            onChange={(e) => handleChange(e?.target?.value, "nomeJuiz")}
            value={exameStore?.exame?.nomeJuiz || ""}
          />
        </div>
        <div>
          <label className={classes.label}>Nome do identificador:</label>
          <InputForm
            id="pac-tpt-inp-ide"
            classes={{ input: classes.input }}
            onChange={(e) =>
              handleChange(e?.target?.value, "nomeIdentificador")
            }
            value={
              exameStore?.exame?.nomeIdentificador || ""
            }
          />
        </div>
      </div>
      <div className={classes.content}>
        <div className={classes.contentParticipantes}>
          <div className={classes.title}>
            PARTICIPANTES DO EXAME DE PATERNIDADE
          </div>
          <Participantes participante={"Filho"} campo ={"Filho"} idPrefix="pac-tpt-fil"/>
          <Participantes participante={"Mae"} sexo={"Feminino"} campo ={"Mae"} idPrefix="pac-tpt-mae"/>
          <Participantes participante={"Suposto pai"} sexo={"Masculino"} campo ={"SupostoPai"} idPrefix="pac-tpt-pai"/>
        </div>
      </div>
    </div>
  );
});

const styles = {
  input: {
    background: "#f2f2f2",
    border: "none",
    paddingTop: "6px !important",
    color: "#505050",
  },
  label: {
    fontSize: "12px",
    color: "#868686",
  },
  content: {
    display: "flex",
    gap: "10px",
  },
  contentParticipantes: {
    display: "flex",
    flexDirection: "column",
  },
  title: {
    fontSize: "12px",
    fontWeight: 600,
    color: "#219A97",
    padding: "5px",
  },
};

const TestePaternidadeWithStyles = withStyles(styles)(TestePaternidade);
const stores = ["exameStore"];

export default inject(...stores)(TestePaternidadeWithStyles);
